import React from 'react'

import { SvgProps } from '../../model/types'

const DeleteIcon: React.FC<SvgProps> = props => {
	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			width="20"
			height="20"
			viewBox="0 0 20 20"
			fill="currentColor"
			{...props}
		>
			<path d="M11.8993 1.66666C12.6167 1.66666 13.2537 2.12571 13.4805 2.80627L13.934 4.16666H16.6667C17.1269 4.16666 17.5 4.53976 17.5 4.99999C17.5 5.46021 17.1269 5.83331 16.6667 5.83332L16.6646 5.8927L15.9417 16.0114C15.8483 17.3197 14.7597 18.3333 13.4482 18.3333H6.55187C5.24027 18.3333 4.15167 17.3197 4.05822 16.0114L3.33545 5.8927C3.33403 5.87278 3.33332 5.85298 3.3333 5.83332C2.87307 5.83331 2.5 5.46021 2.5 4.99999C2.5 4.53976 2.8731 4.16666 3.33333 4.16666H6.06603L6.51949 2.80627C6.74635 2.12571 7.38325 1.66666 8.10063 1.66666H11.8993ZM14.9979 5.83332H5.00213L5.72065 15.8927C5.7518 16.3288 6.11467 16.6667 6.55187 16.6667H13.4482C13.8853 16.6667 14.2482 16.3288 14.2793 15.8927L14.9979 5.83332ZM8.33333 8.33332C8.76071 8.33332 9.11292 8.65501 9.16106 9.06947L9.16667 9.16666V13.3333C9.16667 13.7936 8.79358 14.1667 8.33333 14.1667C7.90597 14.1667 7.55374 13.845 7.50561 13.4305L7.5 13.3333V9.16666C7.5 8.70641 7.87309 8.33332 8.33333 8.33332ZM11.6667 8.33332C12.1269 8.33332 12.5 8.70641 12.5 9.16666V13.3333C12.5 13.7936 12.1269 14.1667 11.6667 14.1667C11.2064 14.1667 10.8333 13.7936 10.8333 13.3333V9.16666C10.8333 8.70641 11.2064 8.33332 11.6667 8.33332ZM11.8993 3.33332H8.10063L7.82286 4.16666H12.1772L11.8993 3.33332Z" />
		</svg>
	)
}

export default DeleteIcon
